import React, { useEffect, useRef, useState } from "react";
import DateColumn from "./components/DateColumn";
import { useLSStore } from "../../context/ls-store";
import { flushSync } from "react-dom";
import moment from "moment";
import AppointmentFilterModal from "./components/AppointmentFilterModal";
import AppointmentSelectModal from "./components/AppointmentSelectModal";
import AppointmentOptions from "./components/AppointmentOptions";
import AppointmentAddModal from "./components/AppointmentAddModal";
import PublishAppointmentModal from "./components/PublishAppointmentModal";
import PublishSuccessCard from "./components/PublishSuccessCard";
import {
  useFetchAppointmentsMutation,
  useFetchProviderFiltersMutation,
  useFilterAppointmentOptionsMutation,
  useGetAppointmentCountMutation,
  useOptimiseDayMutation,
  useRescheduleAppointmentMutation,
  useUpdateAppointmentMutation,
} from "../../features/appointment/appointmentApiSlice";
import {
  useGetProvidersMutation,
} from "../../features/organisation/organisationApiSlice";
import {
  useGetProviderAvailabilityMutation,
} from "../../features/provider/providerApiSlice";
import { selectUser } from "../../features/auth/authSlice";
import { useSelector } from "react-redux";
import ReusableModal from "../../components/Modals/ReusableModal";
import AvailibilityWarningModal from "./components/AvailibilityWarningModal";
import MapV2 from "../../components/Maps/MapV2";
import CloseSvg from "../../assets/svgs/CloseSvg";
import classNames from "classnames";
import { Tooltip } from "@mui/material";
import InfoModal from "../../components/Modals/InfoModal";
import BulkActionsModal from "./components/BulkActionsModal";
import tzlookup from "tz-lookup";
import { LEAVE_TYPE } from "../Schedules/Configure/ProvidersConfig/components/ProviderSettingsModal";
import { capitalizeFirstWords } from "../../utilities/resuseFunctions";
import { APPOINTMENT_CREATED_FROM } from "../../constants/config.constants";

const bgColorsMap = {
  Monday: "bg-primaryblack",
  Tuesday: "bg-primaryblue",
  Wednesday: "bg-primarygreen",
  Thursday: "bg-primaryorange",
  Friday: "bg-primaryred",
  Saturday: "bg-primarytextgrey",
  Sunday: "bg-primarytextgrey",
};

const textColorsMap = {
  Monday: "text-primaryblack",
  Tuesday: "text-primaryblue",
  Wednesday: "text-primarygreen",
  Thursday: "text-primaryorange",
  Friday: "text-primaryred",
  Saturday: "text-primarytextgrey",
  Sunday: "text-primarytextgrey",
};

const LongitudinalSchedules = () => {
  const [appointments, setAppointments] = useState([]);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedProvidersAvailability, setSelectedProviderAvailability] = useState([]);
  const [weeksAvailability, setWeeksAvailability] = useState({});
  const [weeksAvailabilityTime, setWeeksAvailabilityTime] = useState({});
  const [loaderVisible, setLoaderVisible] = useState(true);
  const [weeks, setWeeks] = useState(null);
  const [recallSchedule, setRecallSchedule] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [publishOpen, setPublishOpen] = useState(false);

  const [appointmentStatus, setAppointmentStatus] = useState("All");
  const [locationType, setLocationType] = useState("All");
  const [appointmentType, setAppointmentType] = useState("All");
  const [community, setCommunity] = useState("All");
  const [patient, setPatient] = useState({
    patientId: "All",
    patientName: "All",
  });
  const selectedAppointment = useLSStore((state) => state.selectedAppointment);

  const [successCard, setSuccessCard] = useState(false);

  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [patients, setPatients] = useState([]);

  const [availability, setAvailability] = useState([]);
  const [providerTimezone, setProviderTimezone] = useState(null);

  const filterOpen = useLSStore((state) => state.filterOpen);
  const draggingAppointment = useLSStore((state) => state.draggingAppointment);
  const defaultWeekIndx = useLSStore((state) => state.defaultWeekIndx);
  const setDefaultWeekIndx = useLSStore((state) => state.setDefaultWeekIndx);

  const setFilterOpen = useLSStore((state) => state.setFilterOpen);

  const [rescheduleAppointments, { isLoading }] =
    useRescheduleAppointmentMutation();
  const [updateAppointment, { isLoading: updateAppointmentLoading }] =
    useUpdateAppointmentMutation();

  const [startDate, setStartDate] = useState("");
  const [startDateOpen, setStartDateOpen] = useState(false);

  const [endDate, setEndDate] = useState("");
  const [endDateOpen, setEndDateOpen] = useState(false);

  const [calendarStartDate, setCalendarStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [calendarEndDate, setCalendarEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const [filterOptions, setFilterOptions] = useState(null);
  const [moveData, setMoveData] = useState(null);
  const containerRef = React.useRef(null);
  const [showError, setShowError] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);

  const estTimezone = "America/New_York";

  useEffect(() => {
    if (moveData !== null) {
      console.log("moveData", moveData);
    }
  }, [moveData]);

  const [optimiseDay, { isLoading: optimiseLoading }] =
    useOptimiseDayMutation();

  const handleOptimiseCall = async (date, providerId) => {
    try {
      setOptimiseError(null);

      await optimiseDay({
        date,
        providerId,
      }).unwrap();

      setRecallSchedule(true);

      handleOptimise();
    } catch (err) {
      setOptimiseError(err?.data?.message);
    }
  };

  const onDrop = async (
    column,
    index,
    isAvailable,
    suggestedAppointment = null
  ) => {
    try {
      if (draggingAppointment === null && suggestedAppointment === null) return;

      let appointmentId;

      if (suggestedAppointment) appointmentId = suggestedAppointment;
      else appointmentId = draggingAppointment;

      if (!isAvailable) {
        setMoveData({
          column,
          index,
          appointmentId,
        });
        setWarningModalOpen(true);
        return;
      }

      const { data } = await rescheduleAppointments({
        dayToBeMoved: weeks[defaultWeekIndx][column].date,
        indexToBeMoved: index + 1,
        appointmentId: appointmentId,
        practiceId: user?.organisation?.practiceId,
      }).unwrap();

      const { fromDate, toDate, appointmentsTo, appointmentsFrom } = data;

      const newAppointments = {
        ...appointments,
        [weeks[defaultWeekIndx][column].date]: appointmentsTo,

      };

      if (fromDate !== toDate) {
        newAppointments[fromDate] = appointmentsFrom;
      }

      if (document.startViewTransition) {
        document.startViewTransition(() => {
          flushSync(() => {
            setAppointments(newAppointments);
          });
        });
      } else {
        setAppointments(newAppointments);
      }

      setMoveData(null);
    } catch (error) {
      // console.log(error, "err");
      setShowError(error?.data?.errors);
    }
  };

  const onAdd = (colIndx, appt) => {
    const newAppts = appointments.map((x, ind) => {
      const appts = appointments[ind];

      if (ind === colIndx) {
        appts.push(appt);

        return appts;
      }

      return appts;
    });

    setAppointments(newAppts);
  };

  const handleVisitType = async (id, visitType, appointmentDate) => {
    try {
      await updateAppointment({
        id,
        appointmentType: Number(visitType),
        practiceId: user?.organisation?.practiceId,
      }).unwrap();
      
      const appointmentsList = appointments[appointmentDate];
      if (!appointmentsList) {
        return;
      }
      
      const updatedAppointments = appointmentsList.map((appt) => {
        if (appt.appointmentId === id) {
          const apptType = appointmentTypes.find((type) => type.id === Number(visitType));
          return {
            ...appt,
            appointmentType: {
              id: visitType,
              name: apptType?.name,
              isTelehealth: apptType?.is_telehealth,
              duration: apptType?.duration,
            },
          };
        }
        return appt;
      });
      
      const updatedAppts = {
        ...appointments,
        [appointmentDate]: updatedAppointments,
      };
      
      setAppointments(updatedAppts);
    } catch (error) {
      console.error(error);
      setShowError(
        error?.data?.errors || [
          {
            id: 1,
            error: error?.data?.message ?? error?.message,
          },
        ]
      );
    }
  };

  const getDatesInMonth = (month, year) => {
    const startDate = moment().subtract(3, "month").startOf("week").add(1, "day");
    const endDate = moment(startDate).add(364, "day");

    const weeks = [];
    let currentWeek = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      currentWeek.push({
        date: currentDate.format("YYYY-MM-DD"),
        day: currentDate.format("ddd").toUpperCase(),
      });

      if (
        currentDate.isoWeekday() === 7 ||
        currentDate.isSame(endDate, "day")
      ) {
        weeks.push(currentWeek);
        currentWeek = [];
      }

      currentDate = currentDate.clone().add(1, "day");
    }

    return weeks;
  };

  const fetchAppointmentsFunction = async () => {
    try {
      const marketid =
        user.type === 3 && selectedMarket
          ? selectedMarket.market.id
          : selectedProvider?.provider_market_id;
      const { data } = await fetchAppointments({
        providerId: selectedProvider?.id,
        appointmentType:
          appointmentType === "0" || appointmentType === "All"
            ? "All"
            : Number(appointmentType),
        locationType,
        appointmentStatus,
        communityId: community === "All" ? null : community,
        patientId: patient === "All" ? null : Number(patient),
        startDate: weeks?.[defaultWeekIndx]?.[0]?.date,
        endDate:
          weeks?.[defaultWeekIndx]?.[weeks?.[defaultWeekIndx]?.length - 1]
            ?.date,
        fromApp: false,
        // marketId: selectedProvider?.provider_market_id
        marketId: marketid
      });

      setAppointments(data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const [locationOnMap, setLocationOnMap] = useState(null);

  useEffect(() => {
    if (appointments != undefined && weeks != null) {
      const uniqueAppointmentLocationsByDate = weeks[defaultWeekIndx].map(
        (day) => {
          const date = day.date;
          const appointmentsForDate = appointments[date];

          const uniqueLocationIds = new Set();

          const uniqueLocations = new Set();

          const uniqueLocationMinSequence = new Map();
          const uniqueLocationMaxSequence = new Map();

          if (appointmentsForDate != undefined) {
            appointmentsForDate.forEach((appointment) => {
              if (!uniqueLocationIds.has(appointment.location.id)) {
                uniqueLocationIds.add(appointment.location.id);
                uniqueLocations.add(appointment.location);

                uniqueLocationMinSequence.set(
                  appointment.location.id,
                  appointment.sequenceNo
                );
                uniqueLocationMaxSequence.set(
                  appointment.location.id,
                  appointment.sequenceNo
                );
              } else {
                const minSequence = uniqueLocationMinSequence.get(
                  appointment.location.id
                );
                const maxSequence = uniqueLocationMaxSequence.get(
                  appointment.location.id
                );

                if (appointment.sequenceNo < minSequence) {
                  uniqueLocationMinSequence.set(
                    appointment.location.id,
                    appointment.sequenceNo
                  );
                }

                if (appointment.sequenceNo > maxSequence) {
                  uniqueLocationMaxSequence.set(
                    appointment.location.id,
                    appointment.sequenceNo
                  );
                }
              }
            });
          }

          const patientNameByLocation = [];

          if (appointmentsForDate != undefined) {
            appointmentsForDate.forEach((appointment) => {
              patientNameByLocation.push({
                locationId: appointment.location.id,
                patientId: appointment.patient.id,
                patientName: appointment.patient.name,
                sequenceNo: appointment.sequenceNo,
              });
            });
          }

          return {
            date,
            day:
              day.day === "SUN"
                ? "Sunday"
                : day.day === "MON"
                  ? "Monday"
                  : day.day === "TUE"
                    ? "Tuesday"
                    : day.day === "WED"
                      ? "Wednesday"
                      : day.day === "THU"
                        ? "Thursday"
                        : day.day === "FRI"
                          ? "Friday"
                          : "Saturday",
            locations: Array.from(uniqueLocations).map((location) => {
              const patients = patientNameByLocation
                .filter((x) => x.locationId === location.id)
                .map((x) => ({
                  id: x.patientId,
                  name: x.patientName,
                  sequenceNo: x.sequenceNo,
                }));

              return {
                ...location,
                minSequence: uniqueLocationMinSequence.get(location.id),
                maxSequence: uniqueLocationMaxSequence.get(location.id),
                patients,
              };
            }),
          };
        }
      );

      setLocationOnMap(uniqueAppointmentLocationsByDate);
    }
  }, [appointments]);

  const fetchFilterOptions = async (date = null) => {
    try {
      if (selectedProvider !== null) {
        const { data } = await filterAppointmentOptions({
          providerId: selectedProvider.id,
          date: date ?? weeks?.[defaultWeekIndx]?.[0]?.date,
          marketId: selectedProvider?.provider_market_id
        });

        setFilterOptions(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const user = useSelector(selectUser);

  const getProvidersFunction = async () => {
    try {
      const { data } = await getProviders({
        orgId: user.organisation.id,
        limit: 0,
        status: ["ACTIVE"],
        showZones: false,
        showConstraints: true,
        showLeaves: false,
      }).unwrap();

      setProviders(data.filter((x) => x.coords !== null));
    } catch (err) {
      console.error(err);
    }
  };

  // const getProvidersAvailabilityFunction = async () => {
  //   try {
  //     const calendarDates = weeks?.[defaultWeekIndx]?.map((e) => e?.date);
  //     const startDate = moment(calendarDates?.[0], 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD');
  //     const endDate = moment(calendarDates?.[calendarDates?.length - 1], 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD');
  //     let { data } = await getProviderAvailability({
  //       id: selectedProvider.id, indexDate: startDate, market_id: selectedProvider?.provider_market_id
  //     }).unwrap();

  //     const availability = { ...data };

  //     if (startDate !== endDate) {
  //       const { data: secondMonthData } = await getProviderAvailability({
  //         id: selectedProvider.id, indexDate: endDate
  //       }).unwrap();

  //       const availabilityJson = data?.availability_json ? JSON.parse(data?.availability_json) : [];
  //       const availabilityJson2 = secondMonthData?.availability_json ? JSON.parse(secondMonthData?.availability_json) : [];

  //       const finalAvailability = [...availabilityJson, ...availabilityJson2];
  //       availability['availability_json'] = JSON.stringify(finalAvailability);
  //     }
  //     // setProvidersAvailability(data);
  //     calculateProviderAvailability(availability, startDate, endDate);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const getProvidersAvailabilityFunction = async () => {
    try {
      if (!weeks?.[defaultWeekIndx]?.length || !selectedProvider?.id) return;

      const calendarDates = weeks[defaultWeekIndx].map(e => e?.date);

      const startDate = moment(calendarDates[0])
        .startOf("month")
        .format("YYYY-MM-DD");

      const endDate = moment(calendarDates[calendarDates.length - 1])
        .startOf("month")
        .format("YYYY-MM-DD");

      const marketId =
        user.type === 3
          ? selectedMarket?.market?.id
          : selectedProvider?.provider_market_id;

      if (!marketId) return;

      const { data: firstMonthData } = await getProviderAvailability({
        id: selectedProvider.id,
        indexDate: startDate,
        market_id: marketId,
      }).unwrap();

      let availabilityJson = firstMonthData?.availability_json
        ? JSON.parse(firstMonthData.availability_json)
        : [];

      if (startDate !== endDate) {
        try {
          const { data: secondMonthData } = await getProviderAvailability({
            id: selectedProvider.id,
            indexDate: endDate,
            market_id: marketId,
          }).unwrap();

          const availabilityJson2 = secondMonthData?.availability_json
            ? JSON.parse(secondMonthData.availability_json)
            : [];

          availabilityJson = [...availabilityJson, ...availabilityJson2];
        } catch (err) {
          console.log(
            "Availability not found for second month:",
            endDate
          );
        }
      }
      const availability = {
        ...firstMonthData,
        availability_json: JSON.stringify(availabilityJson),
      };

      calculateProviderAvailability(availability, startDate, endDate);

    } catch (err) {
      console.error("Availability fetch failed:", err);
    }
  };

  const fetchProviderFilters = async (provider) => {
    // console.log(provider, ">> provider >>>");
    const marketId =
      user.type === 3 && selectedMarket
        ? selectedMarket?.market?.id == "ALL" ? provider?.provider_market_id : selectedMarket?.market?.id
        : provider?.provider_market_id;
    const { data } = await fetchProviderFiltersAPI({
      providerId: provider.providerId || provider.id, marketId
    }).unwrap();
    setAppointmentTypes(data.appointmentTypes);
    setCommunities(data.communities);
    setPatients(data.patientsList);
  };

  const calculateProviderAvailability = (data, startDate, endDate) => {
    // const leaves = await fetchProviderLeaves(selectedProvider.id)
    const monthlyAvailabilities = data?.availability_json ? JSON.parse(data?.availability_json) : [];
    const { day_preferences, working_days } = data?.weekly_availability || {};
    const { leaves } = data;

    const monthlyAvailability = transformedMonthlyAvailability(monthlyAvailabilities);
    const weeklySettings = transformedWeeklySettings(day_preferences, working_days, startDate, endDate);
    const providerLeaves = transformedLeaves(leaves || []);

    const availability = generateMergedEvents(monthlyAvailability, weeklySettings, providerLeaves, leaves);

    setSelectedProviderAvailability(availability);
  }

  useEffect(() => {
    const newWeeks = getDatesInMonth(1, 2024);
    newWeeks.pop();
    setDefaultWeekIndx(newWeeks.findIndex(week => week.some(x => moment(x.date).isSame(moment(new Date()), "day"))));
    setWeeks(newWeeks);
    getProvidersFunction();
    fetchAppointmentsFunction();
    fetchFilterOptions();
  }, []);

  useEffect(() => {
    fetchFilterOptions();
    if (selectedProvider) {
      try {
        const providerTimezone = tzlookup(
          selectedProvider?.coords?.lat,
          selectedProvider?.coords?.lng
        );
        setProviderTimezone(providerTimezone);
      } catch (error) {
        setProviderTimezone(estTimezone);
      }
    }
  }, [selectedProvider]);

  // useEffect(() => {
  //   // getProvidersAvailabilityFunction();
  // }, [selectedProvider, providersAvailability]);

  useEffect(() => {
    if (providers.length && selectedProvider === null && user) {
      setSelectedProvider(
        user.type === 1
          ? providers[0]
          : providers.find((x) => x.id === user.details.provider_id)
      );
    }
  }, [providers, appointments]);

  useEffect(() => {
    if (weeks !== null && selectedProvider !== null) {
      setAppointments([]);
      fetchAppointmentsFunction();
      getProvidersAvailabilityFunction();
    }
  }, [defaultWeekIndx, selectedProvider, weeks, selectedMarket]);

  useEffect(() => {
    if (weeks && selectedProvidersAvailability) {
      const weekAvailability = {}
      const weekAvailabilityTime = {}
      weeks[defaultWeekIndx].map((x, indx) => {
        weekAvailability[x.date] = findAvailability(x);
        weekAvailabilityTime[x.date] = findAvailabilityTime(x);

        setWeeksAvailability(weekAvailability)
        setWeeksAvailabilityTime(weekAvailabilityTime)
      });
    }
  }, [defaultWeekIndx, weeks, selectedProvidersAvailability]);

  useEffect(() => {
    if (recallSchedule) {
      // setAppointments([]);
      fetchAppointmentsFunction();
      fetchAppointmentCount();
      setRecallSchedule(false);
    }
  }, [recallSchedule]);

  useEffect(() => {
    if (selectedProvider !== null) {
      fetchProviderFilters(selectedProvider);
    }
  }, [selectedProvider]);

  useEffect(() => {
    if (appointments.length !== 0) {
      setLoaderVisible(false);
    }
  }, [appointments]);

  const [fetchAppointments, { isLoading: isAppointmentsLoading }] =
    useFetchAppointmentsMutation();
  const [getProviders, { isLoading: isProvidersLoading }] =
    useGetProvidersMutation();
  const [
    getProviderAvailability,
    { isLoading: isProvidersAvailabilityLoading },
  ] = useGetProviderAvailabilityMutation();
  const [filterAppointmentOptions, { isLoading: isFiltersLoading }] =
    useFilterAppointmentOptionsMutation();
  const [fetchProviderFiltersAPI, { isLoading: isProviderFiltersLoading }] =
    useFetchProviderFiltersMutation();
  const [getAppointmentCount, { isLoading: getLoading }] =
    useGetAppointmentCountMutation();

  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const loading =
    isLoading ||
    isAppointmentsLoading ||
    isProvidersLoading ||
    isProvidersAvailabilityLoading ||
    isProviderFiltersLoading ||
    isFiltersLoading ||
    getLoading;

  const closeWarningModal = () => {
    setWarningModalOpen(false);
  };

  const [openMap, setOpenMap] = useState(false);
  const [openOptimise, setOpenOptimise] = useState(false);
  const [openOptimiseBlocked, setOpenOptimiseBlocked] = useState(false);
  const [dataToOptimise, setDataToOptimise] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [optimiseError, setOptimiseError] = useState(null);
  const [openBulkSchedule, setOpenBulkSchedule] = useState(false);
  const [dataToBulkSchedule, setDataToBulkSchedule] = useState(null);
  const [count, setCount] = React.useState([]);

  const [dragPosition, setDragPosition] = useState({ x: 0, y: 0 });

  const containerRef2 = useRef(null);

  const handleOptimise = (date = null, providerId = null) => {
    if (date != null && providerId != null) {
      const dayAppointments = appointments?.[date] ?? [];
      const hasLockedOrPublished = dayAppointments.some(
        (a) =>
          a.status === "LOCKED" || a.status === "PUBLISHED"
      );
      if (hasLockedOrPublished) {
        setOpenOptimiseBlocked(true);
        return;
      }
      setDataToOptimise({ date, providerId });
    }
    setOpenOptimise(!openOptimise);
    if (date == null && providerId == null) setDataToOptimise(null);
  };

  const handleBulkSchedule = ({
    date = null,
    providerId = null,
    count = null,
    appointments = null,
  }) => {
    setOpenBulkSchedule(!openBulkSchedule);
    if (date != null && providerId != null)
      setDataToBulkSchedule({ date, providerId, count, appointments });
    else setDataToBulkSchedule(null);
  };

  const onMonthChange = (date) => {
    setCalendarStartDate(moment(date).startOf("month").format("YYYY-MM-DD"));
    setCalendarEndDate(moment(date).endOf("month").format("YYYY-MM-DD"));
  };

  const fetchAppointmentCount = async () => {
    try {
      const { data } = await getAppointmentCount({
        providerId:
          user.type === 3
            ? user.details.provider_id
            : selectedProvider?.id || 0,
        organisationId: user.organisation.id,
        startDate: calendarStartDate,
        endDate: calendarEndDate,
        fromApp: false,
        marketId: selectedProvider?.provider_market_id
      }).unwrap();

      setCount(data);
    } catch (error) {
      console.error(error?.data?.message || error?.message);
    }
  };

  const handleDrag = (event) => {
    const { clientX, clientY } = event;
    const container = containerRef.current;

    if (container) {
      const { top, left, bottom, right } = container.getBoundingClientRect();
      const scrollSpeed = 10;

      // Check if the drag is near the container's edges and scroll accordingly
      if (clientX > right - 50)
        container.scrollBy({ left: scrollSpeed, behavior: "smooth" });
      if (clientX < left + 50)
        container.scrollBy({ left: -scrollSpeed, behavior: "smooth" });
      if (clientY > bottom - 50)
        container.scrollBy({ top: scrollSpeed, behavior: "smooth" });
      if (clientY < top + 50)
        container.scrollBy({ top: -scrollSpeed, behavior: "smooth" });

      // Update drag position for custom logic if needed
      setDragPosition({ x: clientX, y: clientY });
    }
  };

  const findAvailability = (data) => {
    const currentDayAvailabilities = selectedProvidersAvailability.filter(({ start }) => moment(start).format('YYYY-MM-DD') === moment(data.date).format('YYYY-MM-DD'));

    if (!currentDayAvailabilities?.length) return false;

    const partialAvailability = currentDayAvailabilities?.filter((e) => e?.type == 'partial');

    if (partialAvailability?.length) {
      return true;
    } else if (!partialAvailability?.length) {
      const availability = currentDayAvailabilities?.filter((e) => !e?.isLeave);
      if (availability?.length) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  };

  const findAvailabilityTime = (data) => {
    const currentDayAvailabilities = selectedProvidersAvailability.filter(({ start }) => moment(start).format('YYYY-MM-DD') === moment(data.date).format('YYYY-MM-DD'));
    if (currentDayAvailabilities?.length) {
      currentDayAvailabilities.sort((a, b) => moment(a.start).diff(moment(b.start)));
      // A day can have multiple independent availability windows (e.g. a
      // morning/afternoon window and a separate evening window). A meeting
      // only splits the window it overlaps into `type: 'partial'` pieces --
      // any other window for the day is untouched and keeps its original
      // type. Returning only the 'partial' pieces when at least one exists
      // silently dropped every untouched window, so instead we return every
      // non-leave entry (both the partial pieces and the untouched windows).
      const availability = currentDayAvailabilities?.filter((e) => !e?.isLeave);
      if (availability?.length) {
        return availability;
      } else {
        return currentDayAvailabilities;
      }
    } else {
      return [];
    }
  };

  const getProviderTimezoneTime = (date, time, timezone) => {
    if (date && time && timezone) {
      const estDateTime = moment.tz(`${date}T${time}`, estTimezone);
      return estDateTime.clone().tz(timezone).format("HH:mm");
    } else {
      return time;
    }
  };

  const getEstTimezoneTime = (date, time, timezone) => {
    if (date && time && timezone) {
      const providerDateTime = moment.tz(`${date}T${time}`, timezone);
      return providerDateTime.clone().tz(estTimezone).format("HH:mm");
    } else {
      return time;
    }
  };

  const transformedMonthlyAvailability = (availabilities) => {
    return availabilities
      ?.filter((i) => !i?.isWeeklyEv)
      ?.flatMap((availability) => {
        const {
          working_days,
          working_hours,
          appointment_type_ids,
          zip_codes,
          zone_ids,
        } = availability || {};
        const { start_time, end_time } = working_hours || {};

        return availability.dates
        ?.filter((date) => {
          const dayName = moment(date).format("dddd").toUpperCase(); // e.g., 'MONDAY'
          return working_days == null
            ? true
            : working_days.includes(dayName);
        })
        .map((date) => {
          const padTime = (time) =>
            time
              .split(":")
              .map((x) => (x.length === 1 ? `0${x}` : x))
              .join(":");

          const toDateTime = (date, time) => new Date(`${date}T${time}`);

          const startTimeStr = providerTimezone
            ? getProviderTimezoneTime(date, padTime(start_time), providerTimezone)
            : padTime(start_time);

          const endTimeStr = providerTimezone
            ? getProviderTimezoneTime(date, padTime(end_time), providerTimezone)
            : padTime(end_time);

          const startDateTime = toDateTime(date, startTimeStr);
          const endDateTime = toDateTime(date, endTimeStr);

          // const formattedStart = startDateTime.toLocaleTimeString([], {
          //   hour: "2-digit",
          //   minute: "2-digit",
          // });
          const formattedStart = moment(startDateTime).format("hh:mm A");
          // const formattedEnd = endDateTime.toLocaleTimeString([], {
          //   hour: "2-digit",
          //   minute: "2-digit",
          // });
          const formattedEnd = moment(endDateTime).format("hh:mm A");
          return {
            start: startDateTime,
            end: endDateTime,
            title: `${formattedStart} to ${formattedEnd}`,
            time_slots: [`${start_time}-${end_time}`],
            appointment_type_ids,
            zip_codes,
            zone_ids,
            dates: availability?.dates,
            isMonthlyEv: true
          };
        });
      })
  }

  const transformedWeeklySettings = (dayPreferences, workingDays, startDate, endDate) => {
    try {
      if (!dayPreferences) return [];

      const weeklyEvents = [];
      // const deletedDates = []
      const currentMonth = moment(startDate).startOf("month");
      const endOfMonth = moment(endDate).endOf("month");

      // Helper function to get day number (0-6) from day name
      const getDayNumber = (dayName) => {
        const dayMap = {
          SUNDAY: 0,
          MONDAY: 1,
          TUESDAY: 2,
          WEDNESDAY: 3,
          THURSDAY: 4,
          FRIDAY: 5,
          SATURDAY: 6,
        };
        return dayMap[dayName];
      };

      // Process each day's preferences
      if (workingDays && workingDays?.length) {
        workingDays?.forEach((day) => {
          if (day === "ALL") return; // Skip the ALL settings as they're defaults

          const preferences = dayPreferences?.[day] || dayPreferences?.["ALL"];

          if (preferences) {
            const { working_hours } = preferences || {};
            if (!working_hours?.start || !working_hours?.end) return;

            // Get all dates of this day in the current month
            let date = moment(currentMonth);
            while (date.isSameOrBefore(endOfMonth)) {
              if (date.day() === getDayNumber(day)) {
                const dateStr = date.format("YYYY-MM-DD");
                const start_time = getProviderTimezoneTime(
                  dateStr,
                  working_hours.start,
                  providerTimezone
                );
                const end_time = getProviderTimezoneTime(
                  dateStr,
                  working_hours.end,
                  providerTimezone
                );
                const startDateTime = `${dateStr}T${start_time}`;
                const endDateTime = `${dateStr}T${end_time}`;

                const formattedStart = moment(startDateTime).format("hh:mm A");
                const formattedEnd = moment(endDateTime).format("hh:mm A");

                if (
                  !preferences?.deleted_dates?.includes(
                    date.format("YYYY-MM-DD")
                  )
                ) {
                  weeklyEvents.push({
                    start: new Date(startDateTime),
                    end: new Date(endDateTime),
                    title: `${formattedStart} to ${formattedEnd}`,
                    time_slots: [`${start_time}-${end_time}`],
                    appointment_type_ids: preferences.appointment_type_ids,
                    zone_ids: preferences.zone_ids,
                    zip_codes: preferences.zip_codes,
                    dates: [date.format("YYYY-MM-DD")],
                    isWeeklyEv: true,
                    day: day,
                  });
                }
              }
              date = date.add(1, "day");
            }
          }
        });
      }

      return weeklyEvents;
    } catch (error) {
      console.error(error);
    }
  };

  const transformedLeaves = (leaves) => {
    return leaves?.map((leave) => {
      const startDate = moment(leave.startDate, "YYYY-MM-DD").startOf("day").toDate();
      const endDate = moment(leave.endDate, "YYYY-MM-DD").endOf("day").toDate();
      // const startTime = getProviderTimezoneTime(leave?.startDate, leave?.startTime, providerTimezone);
      // const endTime = getProviderTimezoneTime(leave?.endDate, leave?.endTime, providerTimezone);
      const startTime = leave?.startTime;
      const endTime = leave?.endTime;

      return {
        start: startDate,
        end: endDate,
        startTime: startTime,
        endTime: endTime,
        title: `Absence: ${capitalizeFirstWords(LEAVE_TYPE[leave.type].replaceAll("_", " "))
          }${leave.startTime && leave.endTime
            ? ` (${moment(startTime, "HH:mm").format("hh:mm A")} - ${moment(endTime, "HH:mm").format("hh:mm A")})`
            : ""
          }`,
        isLeave: true,
        leaveType: leave.type,
      }
    }) || [];
  }

  function generateMergedEvents(transformedMonthlyEvents = [], transformedWeeklySettings = [], transformedLeaves = [], leaves = []) {
    const getDateStr = (date) => moment(date).format("YYYY-MM-DD");

    // 1. Index all leaves by date
    const leaveMap = {};
    (leaves || []).forEach((leave) => {
      const start = moment(leave.startDate, "YYYY-MM-DD");
      const end = moment(leave.endDate, "YYYY-MM-DD");
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!leaveMap[dateStr]) leaveMap[dateStr] = [];
        leaveMap[dateStr].push(leave);
        current.add(1, "day");
      }
    });

    // 2. Combine provider and weekly availability
    const allAvailEvents = [...(transformedMonthlyEvents || []), ...(transformedWeeklySettings || [])];

    // 3. Group availabilities by date
    const availByDate = {};
    allAvailEvents.forEach((ev) => {
      const start = moment(ev.start);
      const end = moment(ev.end);
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!availByDate[dateStr]) availByDate[dateStr] = [];
        availByDate[dateStr].push(ev);
        current.add(1, "day");
      }
    });

    // 4. Merge logic
    let merged = [];
    const processedDates = new Set();

    Object.keys({ ...availByDate, ...leaveMap }).forEach((dateStr) => {
      processedDates.add(dateStr);
      const leavesForDay = leaveMap[dateStr] || [];
      let availsForDay = availByDate[dateStr] || [];

      const monthlyEvents = availsForDay.filter(ev => ev.isMonthlyEv);
      const weeklyEvents = availsForDay.filter(ev => ev.isWeeklyEv);
      let finalAvailsForDay = [];

      if (monthlyEvents.length && weeklyEvents.length) {
        const overlaps = weeklyEvents.map(weeklyEv => {
          return monthlyEvents.some(monthlyEv => {
            const [weStartTime, weEndTime] = weeklyEv.time_slots[0].split('-');
            const [meStartTime, meEndTime] = monthlyEv.time_slots[0].split('-');
            const wStart = moment(weStartTime, 'HH:mm');
            const wEnd = moment(weEndTime, 'HH:mm');
            const mStart = moment(meStartTime, 'HH:mm');
            const mEnd = moment(meEndTime, 'HH:mm');
            return wEnd.isAfter(mStart) && wStart.isBefore(mEnd);
          });
        });

        finalAvailsForDay = [
          ...monthlyEvents,
          ...weeklyEvents.filter((ev, idx) => !overlaps[idx])
        ];
      } else {
        finalAvailsForDay = availsForDay;
      }
      availsForDay = finalAvailsForDay;

      const fullDayLeave = leavesForDay.find((l) => !l.startTime && !l.endTime);
      if (fullDayLeave) {
        const leaveEv = transformedLeaves.find(
          (ev) => getDateStr(ev.start) === dateStr && ev.isLeave
        );
        if (leaveEv) merged.push(leaveEv);
        return;
      }

      let handledAvail = new Set();
      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          availsForDay.forEach((avail, idx) => {
            if (handledAvail.has(idx) || !avail.time_slots) return;
            const [availStartTime, availEndTime] = avail.time_slots[0].split('-');
            const availStart = moment(dateStr + 'T' + availStartTime);
            const availEnd = moment(dateStr + 'T' + availEndTime);
            const leaveStart = moment(dateStr + 'T' + leave.startTime);
            const leaveEnd = moment(dateStr + 'T' + leave.endTime);

            if (availEnd.isAfter(leaveStart) && availStart.isBefore(leaveEnd)) {
              if (leaveStart.isAfter(availStart)) {
                merged.push({
                  ...avail,
                  start: availStart.toDate(),
                  end: leaveStart.toDate(),
                  type: 'partial',
                  title: `${availStart.format("hh:mm A")} to ${leaveStart.format("hh:mm A")}`,
                });
              }

              const leaveEv = transformedLeaves.find(
                (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
                  ev.startTime === leave.startTime && ev.endTime === leave.endTime
              );
              if (leaveEv) merged.push(leaveEv);

              if (leaveEnd.isBefore(availEnd)) {
                merged.push({
                  ...avail,
                  start: leaveEnd.toDate(),
                  end: availEnd.toDate(),
                  type: 'partial',
                  title: `${leaveEnd.format("hh:mm A")} to ${availEnd.format("hh:mm A")}`,
                });
              }

              handledAvail.add(idx);
            }
          });
        }
      });

      availsForDay.forEach((avail, idx) => {
        if (!handledAvail.has(idx)) merged.push(avail);
      });

      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          const leaveEv = transformedLeaves.find(
            (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
              ev.startTime === leave.startTime && ev.endTime === leave.endTime
          );
          if (leaveEv && !merged.some(ev =>
            ev.isLeave &&
            moment(ev.start).isSame(moment(leaveEv.start)) &&
            moment(ev.end).isSame(moment(leaveEv.end)) &&
            ev.startTime === leaveEv.startTime &&
            ev.endTime === leaveEv.endTime
          )) {
            merged.push(leaveEv);
          }
        }
      });
    });

    // Add any leave events not already included
    transformedLeaves.forEach((ev) => {
      const dateStr = getDateStr(ev.start);
      if (!processedDates.has(dateStr)) merged.push(ev);
    });

    // Deduplicate
    const uniqueMerged = merged.filter((event, idx, arr) =>
      idx === arr.findIndex(ev =>
        moment(ev.start).isSame(moment(event.start)) &&
        moment(ev.end).isSame(moment(event.end)) &&
        (ev.startTime || '') === (event.startTime || '') &&
        (ev.endTime || '') === (event.endTime || '') &&
        (ev.title || '') === (event.title || '')
      )
    );

    return uniqueMerged;
  }

  const fetchAvailability = async () => {
    if (startDate && selectedProvider) {
      // const { data } = await getProviderAvailability({id: selectedProvider.id, indexDate: startDate}).unwrap();
      // const leaves = await fetchProviderLeaves(selectedProvider.id)
      // const monthlyAvailabilities = data?.availability_json ? JSON.parse(data?.availability_json) : [];
      // const { day_preferences, working_days } = data?.weekly_availability || {};

      // const monthlyAvailability = transformedMonthlyAvailability(monthlyAvailabilities);
      // const weeklySettings = transformedWeeklySettings(day_preferences, working_days, startDate);
      // const providerLeaves = transformedLeaves(leaves);

      // const availability = generateMergedEvents(monthlyAvailability, weeklySettings,providerLeaves, leaves);
      // setAvailability(availability);
    }
  }

  useEffect(() => {
    if (openMap) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "scroll";
    };
  }, [openMap]);

  useEffect(() => {
    !publishOpen && selectedProvider?.id && fetchAppointmentCount();
  }, [calendarStartDate, selectedProvider]);

  return (
    <div className="overflow-x-hidden relative z-10" ref={containerRef2}>
      {/* {loading && <Loading loading={loading} />} */}
      <PublishSuccessCard
        successCard={successCard}
        setSuccessCard={setSuccessCard}
      />
      {/* <MenuHeader /> */}
      <div className="relative w-full h-[calc(100vh-85px)] overflow-y-auto overflow-x-hidden">
        {weeks !== null && (
          <AppointmentOptions
            filterOpen={filterOpen}
            addOpen={addOpen}
            setFilterOpen={setFilterOpen}
            enableFilter={
              appointmentTypes.length !== 0 &&
              communities.length !== 0 &&
              patients.length !== 0
            }
            providers={providers}
            loaderVisible={loaderVisible || loading}
            selectedProvider={selectedProvider}
            setAddOpen={setAddOpen}
            setSelectedProvider={setSelectedProvider}
            publishOpen={publishOpen}
            setPublishOpen={setPublishOpen}
            weeks={weeks[defaultWeekIndx]}
            weeksList={weeks?.map((week, idx) => {
              return {
                name: `${moment(week[0].date).format("MM/DD/YY")} - ${moment(week[week.length - 1].date).format("MM/DD/YY")}`,
                id: idx,
                isCurrentWeek: week.some(x => moment(x.date).isSame(moment(new Date()), "day"))
              };
            })}
            filtersOn={
              appointmentStatus !== "All" ||
              locationType !== "All" ||
              appointmentType !== "All" ||
              community !== "All" ||
              patient?.patientId !== "All" ||
              patient?.patientName !== "All"
            }
            setOpenMap={setOpenMap}
            selectedMarket={selectedMarket}
            setSelectedMarket={setSelectedMarket}
          />
        )}
        {/* {console.log(appointmentStatus, "APP", locationType, ">>> Location", appointmentType, ">>> App Type", community, ">>> ", patient, ">>> ")} */}
        <div className="flex flex-row overflow-x-auto flex-nowrap h-[calc(100% - 115px)]">
          {weeks !== null &&
            weeks[defaultWeekIndx].map((x, indx) => (
              <DateColumn
                key={indx}
                id={indx}
                info={{
                  date: +x.date.split("-")[2],
                  day: x.day,
                  fulldate: x.date,
                  isAvailable: weeksAvailability[x.date],
                  availableTime: weeksAvailabilityTime[x.date]
                }}
                cards={
                  appointments[x.date] === undefined ? [] : appointments[x.date]
                }
                onDrop={onDrop}
                loaderVisible={loaderVisible || loading}
                addOpen={addOpen}
                publishOpen={publishOpen}
                isToday={moment(new Date()).format("YYYY-MM-DD") === x.date}
                containerRef={containerRef}
                handleDrag={handleDrag}
                handleOptimise={handleOptimise}
                handleBulkSchedule={handleBulkSchedule}
                user={user}
                appointmentTypes={appointmentTypes}
                handleVisitType={handleVisitType}
              />
            ))}
        </div>
      </div>
      {selectedAppointment && (
        <AppointmentSelectModal
          selectedProvider={selectedProvider}
          setRecallSchedule={setRecallSchedule}
          allow={
            {
              create_patient_note: user?.permissions?.includes('calendar_view.create_patient_note_cv'),
              view_patient_note: user?.permissions?.includes('calendar_view.view_patient_note_cv'),
              update_patient_note: user?.permissions?.includes('calendar_view.update_patient_note_cv'),
              create_appointment_note: user?.permissions?.includes('calendar_view.create_appointment_note_cv'),
              update_appointment_note: user?.permissions?.includes('calendar_view.update_appointment_note_cv'),
              delete_appointment_note: user?.permissions?.includes('calendar_view.delete_appointment_note_cv'),
              view_appointment_note: user?.permissions?.includes('calendar_view.view_appointment_note_cv'),
            }
          }
        />
      )}
      {weeks !== null && filterOptions !== null && (
        <AppointmentAddModal
          selectedProvider={selectedProvider}
          addOpen={addOpen}
          setAddOpen={setAddOpen}
          weeks={weeks[defaultWeekIndx]}
          onAdd={onAdd}
          filterOptions={filterOptions}
          setRecallSchedule={setRecallSchedule}
          fetchFilterOptions={fetchFilterOptions}
          created_from={APPOINTMENT_CREATED_FROM.CALENDAR_VIEW}
        />
      )}
      {appointmentTypes.length !== 0 &&
        communities.length !== 0 &&
        patients.length !== 0 && (
          <AppointmentFilterModal
            filterOpen={filterOpen}
            setFilterOpen={setFilterOpen}
            appointmentStatus={appointmentStatus}
            setAppointmentStatus={setAppointmentStatus}
            locationType={locationType}
            setLocationType={setLocationType}
            appointmentTypes={appointmentTypes}
            communities={communities}
            patients={patients}
            appointmentType={appointmentType}
            setAppointmentType={setAppointmentType}
            community={community}
            setCommunity={setCommunity}
            patient={patient}
            setPatient={setPatient}
            setRecallSchedule={setRecallSchedule}
          />
        )}
      <AvailibilityWarningModal
        type="availibility"
        open={warningModalOpen}
        closeWarningModal={closeWarningModal}
        onDrop={onDrop}
        moveData={moveData}
      />
      {weeks !== null && publishOpen && (
        <PublishAppointmentModal
          publishOpen={publishOpen}
          setPublishOpen={setPublishOpen}
          endDate={endDate}
          setEndDate={setEndDate}
          endDateOpen={endDateOpen}
          setEndDateOpen={setEndDateOpen}
          startDate={startDate}
          setStartDate={setStartDate}
          startDateOpen={startDateOpen}
          setStartDateOpen={setStartDateOpen}
          weeks={weeks[defaultWeekIndx]}
          setSuccessCard={setSuccessCard}
          selectedProvider={selectedProvider}
          user={user}
          setRecallSchedule={setRecallSchedule}
        />
      )}
      <ReusableModal open={openOptimiseBlocked} hideHeader>
        <div className="flex flex-col w-96">
          <div className="flex flex-row justify-between items-center p-3">
            <p className="m-0 text-lg font-bold">Cannot optimize route</p>
            <Tooltip title="Close">
              <button
                onClick={() => setOpenOptimiseBlocked(false)}
                className="flex border border-black rounded-full"
              >
                <CloseSvg />
              </button>
            </Tooltip>
          </div>
          <p className="px-3 py-4 m-0 border-t border-b border-primarygrayborder">
            This day has locked or published appointments. Unlock or unpublish
            them to optimize the route.
          </p>
        </div>
      </ReusableModal>
      <ReusableModal open={openOptimise && dataToOptimise !== null} hideHeader>
        <div className="flex flex-col w-96">
          <div className="flex flex-row justify-between items-center p-3">
            <p className="m-0 text-lg font-bold">Optimize Route?</p>
            <Tooltip title="Close">
              <button
                disabled={optimiseLoading}
                onClick={() => {
                  handleOptimise();
                  setOptimiseError(null);
                }}
                className={classNames(
                  "flex border border-black rounded-full",
                  optimiseLoading && "opacity-40"
                )}
              >
                <CloseSvg />
              </button>
            </Tooltip>
          </div>
          <p className="px-3 py-4 m-0 border-t border-b border-primarygrayborder">
            We will optimize this day's schedule to reduce the mileage. Press
            Optimize to confirm this action
          </p>
          {optimiseError != null && (
            <p className="px-3 py-1 m-0 text-sm font-medium text-center text-red-400 border-b border-primarygrayborder">
              <span className="m-0 font-bold">Error</span>: {optimiseError}
            </p>
          )}
          <div className="p-3 ml-auto">
            <button
              disabled={optimiseLoading}
              onClick={() => {
                handleOptimiseCall(
                  dataToOptimise?.date,
                  dataToOptimise?.providerId
                );
              }}
              className={classNames(
                "px-3 py-2 font-bold text-white rounded-md bg-primaryblue",
                optimiseLoading && "opacity-40"
              )}
            >
              Optimize
            </button>
          </div>
        </div>
      </ReusableModal>
      <ReusableModal open={openMap} hideHeader>
        <div className="flex flex-row gap-4 items-start p-4">
          <div className="overflow-clip rounded-lg border border-black">
            <MapV2
              locationOnMap={locationOnMap?.filter(
                (day) => selectedDay === null || day.day === selectedDay
              )}
              selectedProvider={selectedProvider}
            />
          </div>
          <div className="flex flex-col gap-2">
            {[
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ].map((day, idx) => (
              <button
                onClick={() => {
                  if (day === selectedDay) {
                    setSelectedDay(null);
                  } else {
                    setSelectedDay(day);
                  }
                }}
                className={classNames(
                  "flex flex-row items-center gap-2 p-2 font-semibold bg-opacity-10 rounded-lg",
                  selectedDay === day ? bgColorsMap[day] : "bg-none"
                )}
                key={idx}
              >
                <div
                  className={classNames(
                    "w-5 h-5 rounded-full",
                    bgColorsMap[day]
                  )}
                />
                <p className={classNames("m-0", textColorsMap[day])}>{day}</p>
              </button>
            ))}
          </div>
          <Tooltip title="Close">
            <button onClick={() => setOpenMap(false)} className="flex">
              <CloseSvg />
            </button>
          </Tooltip>
        </div>
      </ReusableModal>

      {showError != null && (
        <InfoModal
          open={showError != null}
          errors={showError}
          title="Something went wrong!"
          type={"error"}
          handleClose={() => {
            setShowError(null);
          }}
        />
      )}
      {openBulkSchedule && (
        <BulkActionsModal
          isOpen={openBulkSchedule}
          onClose={() => {
            handleBulkSchedule({});
          }}
          scheduleData={dataToBulkSchedule}
          selectedProvider={selectedProvider}
          setRecallSchedule={setRecallSchedule}
          count={count}
          onMonthChange={onMonthChange}
        />
      )}
    </div>
  );
};

export default LongitudinalSchedules;
